import Vue from 'vue';
import Vuex from 'vuex';

import common from './common';
import detail from './detail';
import error from './error';
import home from './home';
import hotsugg from './hotsugg';
import list from './list';
import playlist from './playlist';
import qlist from './qlist';
import savideo from './savideo';
import search from './search';
import star from './star';
import summary from './summary';
import uploader from './uploader';

Vue.use(Vuex);

export function createStore(config) {
  return new Vuex.Store({
    modules: {
      common: common(config),
      home,
      search,
      star,
      list,
      detail,
      hotsugg,
      playlist,
      qlist,
      summary,
      error,
      uploader,
      savideo,
    },
  });
}
